// src/components/Home.js
import React from "react";
import About from "./About";
import Books from "./Books"; 
import Videos from "./Videos";
import Interventions from "./Interventions";
import Articles from "./Articles";
import Testimonies from "./Testimonies";
import Contact from "./Contact";
import Hero from "./Hero";

function Home() {
  return (
    <div>
      <Hero />
      <section id="about">
        <About />
      </section>
      <section id="books">
        <Books />
      </section>
      <section id="videos">
        <Videos />
      </section>
      <section id="interventions">
        <Interventions />
      </section>
      <section id="articles">
        <Articles />
      </section>
      <section id="testimonies">
        <Testimonies />
      </section>
      <section id="contact">
        <Contact />
      </section>
    </div>
  );
}

export default Home;
